import React, { useEffect, useState } from "react";
import subscriptionApi from "../../../utils/api/subscription";
import SubscriptionCard from "./SubscriptionCard";
import { Link } from "react-router-dom";
import StripeContainer from "../../Payment/stripeContainer";
import TermsAndConditions from "./TermsAndConditions";
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  IconButton, 
  Checkbox, 
  FormControlLabel,
  Typography,
  Box
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const Subscription: React.FC<any> = ({ domainInput, error, setError, isAvailable }) => {
  const [result, setResult] = useState<any>([]);
  const [nextPage, setNextPage] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [processing, setProcessing] = useState(false);

  const freeTrialUserData: any = localStorage.getItem('freeTrialUserData');
  const freeTrialUserParsedData = JSON.parse(freeTrialUserData);

  const [selectedOption, setSelectedOption] = useState(freeTrialUserParsedData ? freeTrialUserParsedData.subscriptionType : '');
  const [selectedFromAddedOnList, setSelectedFromAddedOnList] = useState<any>([]);
  const [subscriptionId, setSubscriptionId] = useState<any>('');

  useEffect(() => {
    subscriptionApi.showAllPublicSubscriptions()
      .then((res) => {
        setResult(res);
      });
  }, []);

  useEffect(() => {
    setError('');
  }, [selectedOption, domainInput]);

  const handleCheckboxChange = (event: any) => {
    setSelectedOption(event.target.value);
    setSubscriptionId(event.target.id);
  };

  const handleTermsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTermsAccepted(event.target.checked);
  };

  const handleTermsClick = (event: React.MouseEvent) => {
    event.preventDefault();
    setShowTermsModal(true);
  };

  const handleTermsModalClose = () => {
    setShowTermsModal(false);
  };

  const extractSelectedAddedOns = () => {
    const filteredSubscriptionData = result.filter((subscriptionEle: any) => subscriptionEle.name === selectedOption);

    if (filteredSubscriptionData.length && filteredSubscriptionData[0].addons) {
      const finalListOfSelectedAddons = filteredSubscriptionData[0].addons.filter((addonEle: any) =>
        selectedFromAddedOnList.includes(addonEle.id)
      );

      return finalListOfSelectedAddons.map((ele: any) => { return {id: ele.id, name: ele.name, feature_ids: ele.feature_ids }});
    }

    return [];
  };

  const onContinueClickHandler = async () => {
    if (processing) return; // Prevent double submission

    if (!isAvailable) {
      setError("Custom URL availability error! Check availability and try again.");
    } else if (domainInput.trim() === '') {
      setError("Custom URL is not valid!");
    } else if (selectedOption === '') {
      setError("Subscription selection can't be empty!");
    } else if (!termsAccepted) {
      setError("Please accept the terms and conditions to continue.");
    } else {
      setProcessing(true);
      setError('');
      localStorage.setItem('freeTrialUserData', JSON.stringify({
        ...freeTrialUserParsedData,
        domain: domainInput,
        subscriptionType: selectedOption,
        subscriptionId: subscriptionId,
        selectedAddOns: extractSelectedAddedOns(),
      }));

      setNextPage(true);
      setProcessing(false);
    }
  };

  const handleClose = () => {
    setNextPage(false);
  };

  return (
    <div className="subscription__wrapper">
      <div className="subscription">
        <h3>Subscription <span>(price per project per month)</span></h3>
        <hr />
      </div>
      <div>
        {result.map((ele: any) => (
          <SubscriptionCard
            key={ele.id}
            id={ele.id}
            name={ele.name}
            description={ele.description}
            price={ele.price}
            addOnList={ele.addons}
            type={'change'}
            handleCheckboxChange={handleCheckboxChange}
            selectedOption={selectedOption}
            selectedFromAddedOnList={selectedFromAddedOnList}
            setSelectedFromAddedOnList={setSelectedFromAddedOnList}
          />
        ))}
      </div>

      {/* Terms and Conditions Checkbox */}
      <Box sx={{ mt: 2, mb: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={termsAccepted}
              onChange={handleTermsChange}
              color="primary"
            />
          }
          label={
            <Typography variant="body2">
              By clicking this checkbox, you agree to our{' '}
              <a 
                href="#" 
                onClick={handleTermsClick}
                style={{ 
                  color: '#1976d2', 
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
              >
                Terms and Conditions
              </a>
            </Typography>
          }
        />
      </Box>

      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div className='subscription__action-buttons'>
        <Link to='/free-trial'>
          <button className='subscription__previous-button'>
            Previous
          </button>
        </Link>
        <button 
          className='subscription__continue-button' 
          onClick={onContinueClickHandler}
          disabled={!termsAccepted || processing}
          style={{
            opacity: (termsAccepted && !processing) ? 1 : 0.6,
            cursor: (termsAccepted && !processing) ? 'pointer' : 'not-allowed'
          }}
        >
          {processing ? 'Processing...' : 'Add Card Details'}
        </button>
      </div>

      {/* Terms and Conditions Modal */}
      <TermsAndConditions 
        open={showTermsModal} 
        onClose={handleTermsModalClose} 
      />

      {/* Stripe Modal */}
      <Dialog open={nextPage} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          Enter Card Details
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <StripeContainer email={freeTrialUserParsedData.email} name={freeTrialUserParsedData.name} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Subscription;
